import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export const Client = (props) => {
  const settings = {
    dots: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div id="client" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Our Clients</h2>
          <p>
            We are proud to have collaborated with esteemed clients across various industries. Here's a glimpse of those who trusted us.
          </p>
        </div>
        <div id="" style={{ paddingBottom: "0" }}>
          {props.data ? (
            <Slider {...settings} className="client-slider">
              {props.data.map((client, i) => (
                <div key={`${client.name}-${i}`} className="col-md-3 col-sm-6 client">
                <div className="thumbnail">
                  {""}
                  <a href={client.link} target="_blank" rel="noopener noreferrer">
                    <img src={client.img} alt={`${client.name}`} className="client-img"/>
                  </a>
                  <div className="caption">
                    <h4>{client.name}</h4>
                  </div>
                </div>
              </div>
              ))}
            </Slider>
          ) : (
            "loading"
          )}
        </div>
      </div>
    </div>
  );
};
